module.exports = __webpack_public_path__ + "static/media/unsplash-bigboy-biggulp.2198027c.jpg";